import styled, { css } from "styled-components";

const StyledTierCell = styled.span`
  color: ${(props) => props.color};
  font-weight: 700;
  width: 10rem;

  ${(props) =>
    props.verdict &&
    css`
      font-size: 1.3rem;
    `}
`;

const StyledTierName = styled.p`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: white;
  font-family: "Cabin", "Helvetica Neue", Helvetica, Arial, sans-serif;
`;

const StyledPillWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const StyledSaphetorErrorMessage = styled.div`
  padding: 0 0 2rem 0;
`;

const StyledGeneralErrorMessage = styled.span`
  color: red;
`;

const StyledVarsomeClinicalMessage = styled.div`
  background-color: #fff;
  text-align: center;
  color: #818a91;
`;

const firstColumnStyles = {
  width: "20rem",
  verticalAlign: "top",
  textAlign: "center",
};

const secondColumnStyles = {
  width: "6rem",
  verticalAlign: "top",
  textAlign: "end",
};

const thirdColumnStyles = {
  verticalAlign: "top",
  color: "#373a3c",
};

const StyledMissenseText = styled.label`
  padding: 1rem 0 0 0;
`;

const StyledPill = styled.td`
  width: 25%;
`;

const StyledUserExplain = styled.td`
  width: 75%;
`;

export {
  StyledTierCell,
  StyledTierName,
  StyledPillWrapper,
  StyledErrorWrapper,
  StyledSaphetorErrorMessage,
  StyledGeneralErrorMessage,
  StyledVarsomeClinicalMessage,
  firstColumnStyles,
  secondColumnStyles,
  thirdColumnStyles,
  StyledMissenseText,
  StyledPill,
  StyledUserExplain,
};
